module.exports = __webpack_public_path__ + "media/ko_kr_s1_ChinSun.692c6424.mp3";